<template>
  <div class="content">
    <s-location buy title="증표 구입"/>

<!--     <template v-if="$store.state.session.user.membstat != '개업'">
      <div class="comment_gray expcomment mt_15">
        <p class="tit">구매 권한이 없습니다.</p>
        <li>현재 <b>{{ $store.state.session.user.membstat }}</b> 상태이기 때문에 증표 구매를 하실 수 없습니다.</li>
      </div>
    </template>
    <template v-else> -->

      <h4 class="sub_title02">증표 구입</h4>

    <!-- <template v-if="$store.state.session.user.type != 'master'"> -->
      <!--  주의사항  -->
      <div v-if="!closedOffice && load_ok" class="comment_gray expcomment mt20">

        <!-- 마스터 또는 김앤장이 아닌 소속변호사만 표시 -->
        <div v-if="$store.state.session.user.type == 'master' || ($store.state.session.user.type == 'member' && org_perm.likeself == '0')">
          <li><input type="checkbox" disabled :checked="org_perm.member_buy == '1'"/> 소속변호사가 증표를 구입할 수 있음</li>
          <li><input type="checkbox" disabled :checked="org_perm.master_buy_member_use == '1'"/> 법무법인 또는 공동법률사무소 아이디로 구입한 증표를 사용할 수 있음</li>
          <li>※ 위 권한은 [마스터 아이디 로그인 - 마이페이지 - 소속변호사 권한 설정]에서 변경 가능합니다.</li>
        </div>
        <li>※ 회원 본인이 구입한 증표 중 미사용 증표는 회원의 소속이 바뀔 경우 <br class="mobile" /><em id="id_msg" class="blue01" style="cursor: pointer">변경된 소속으로 자동전환
          <div class="toggleInfo">
            <p class="tit_info">예시</p>
            <div class="cont" style="font-size: 14px;">
              <p style="color: red;">※ 회원 본인이 구입한 증표 중 미사용 증표는 회원의 소속이 바뀔 경우 변경된 소속으로 자동전환됩니다.</p>
              <ol>
                <li>개인 > 법무법인, 공동법률사무소 소속변호사로  이전할 경우<br/>
                  홍길동 > 홍길동(법무법인 A) </li>
                <li>법무법인, 공동법률사무소 > 개인으로 이전할 경우<br/>
                  홍길동(법무법인 A) > 홍길동 </li>
                <li>법무법인, 공동법률사무소 > 법무법인, 공동법률사무소 이전할 경우<br/>
                  홍길동(법무법인 A) > 홍길동(법무법인 B) </li>
              </ol>
              <p> &nbsp; &nbsp; &nbsp; (회원 소속정보 변경 내역은 다음날 반영됩니다)</p>
            </div>
          </div>
          </em>됩니다.
          </li>
      </div>
    <!-- </template> -->

      <template v-if="!closedOffice && ($store.state.session.user.type != 'member' || org_perm.member_buy == '1')">
        <table class="tbl01 ">
          <thead>
            <tr>
              <th class="viakind">증표 종류</th>
              <th>금액</th>
              <th class="viacnt">수량</th>
              <th>계</th>
            </tr>
          </thead>
          <tr v-for="(item, i) in prod" :key="'prid_'+i" style="height: 57px;"><!-- 이거 높이 제발 없애지 말아 주세요.. 몇번을 수정함. 하고싶어서 하는게 아니라 서울회 요청으로... -->
            <th>{{ item.name }}
              <br/>
              <font>{{ item.sub_name }}</font>
            </th>
            <td class="al_amt">{{ item.price | comma }} 원</td>
            <td class="al_c">
              <input type="text"
                      placeholder="숫자입력"
                      :value="item.cnt"
                      @input="inputCount(item, $event.target.value);"
                      class="al_r b"
                      maxlength="10"
                      v-mask="'########'"
              />
                      <!-- v-money="T.money" -->
            </td>
            <td class="al_amt">{{ item.sumprice | comma }} <template v-if="item.sumprice">원</template></td>
          </tr>
          <tr class="sum">
            <th class="al_c">비고</th>
            <td colspan="3"><input type="text" v-model="sitem.iv_remk" placeholder="예) 홍길동 변호사님 구입 증표임. (증표가 정상 발행되면 해당 증표의 비고 부분에 자동 표시되는 기능입니다)" class="w100p"/></td>
          </tr>
          <tr class="sum">
            <th class="al_c">합계</th>
            <th></th>
            <th class="al_c">{{ sitem.iv_total_cnt | comma }} <template v-if="sitem.iv_total_cnt">장</template></th>
            <th class="al_amt">{{ sitem.iv_total_amt | comma }} <template v-if="sitem.iv_total_amt">원</template></th>
          </tr>
        </table>

        <div class="btn_group">
          <div class="right">
            <button @click="doInit"   class="btn gray01 outline ">초기화</button>
            <button @click="saveItem" class="btn gray01 ">신청하기</button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="comment_gray expcomment mt_15">
          <p class="tit">증표구입 권한이 없습니다.</p>
          <template v-if="closedOffice">
            <li>해산되었거나 소속된 변호사가 없는 단체는 증표를 구입할 수 없습니다.</li>
          </template>
          <template v-else>
            <li>현재 법무법인에서 소속변호사 계정으로 증표를 구입할 수 있는 권한을 부여하지 않은 상태입니다.</li>
            <li>소속변호사 계정으로 증표를 구입 하시려면 법무법인 마스터 계정에서 권한설정을 해 주십시오.</li>
            <p>* 법무법인 마스터 계정 로그인 -> 마이페이지 -> 소속변호사 권한 설정 -> 증표구입 권한에서 증표 구입 가능에 체크 후 저장</p>
          </template>
        </div>
      </template>

<!--     </template> -->
  </div> <!-- content : width=950px; -->

</template>

<script>
let ui
import _config from '../../plugins/config'
export default {
   data () {
    return {
      prod : {},
      sitem : {
        // 고정값
          iv_sellseq     : "0"
        , iv_sellregdt   : this.$moment().format("YYYYMMDD")
        , iv_selldt      : this.$moment().format("YYYYMMDD")
        , iv_sellplac    : 'B21100' // 경유처   : 온라인
        , iv_sellclsf    : 'BB0100' // 판매구분 : 판매
        , iv_payway      : 'VRBANK' // 결제수단 : 가상계좌
        // 프로시저로 안넘어가는 값 빈값으로 넘김
        , iv_rcptno      : ''
        , iv_rcptnoto    : ''
        , iv_agntpersnm  : ''
        , iv_agntpersprn : ''
        , iv_freeclsf    : ''
        , iv_remk        : '' // 비고
        , iv_viaregdt    : ''
        , iv_viaseq      : ''
      },
      org_perm: {},
      load_ok: false,
      closedOffice: false, // 등록 가능한 변호사 없을때
    }
  },
  watch: {
    '$route' : 'doInit',
  },
  created() {
    ui = this.$ui;
    // { "member_buy": "1", "master_buy_member_use": "1" }
    if (this.$store.state.session.user.type != 'self') {  // 개인변호사가 아니면 다 있다
      ui.httpGet("/proc/N_OFFICE_MEM_SEL_DTL", {}, ret => this.org_perm = ret.data.rs1[0], null, v=>this.load_ok = true)
    } else {
      this.load_ok = true
    }

    if (this.$store.state.session.user.type == 'master') {  // 마스터인경우. 등록가능한 소속변호사가 없는가 ?
      ui.httpGet("/proc/N_OFFICE_CLOSEYN", {}, ret => this.closedOffice = _.get(ret, "data.rs1[0].closeyn", 'N') == 'Y')
    }

    ui.httpGet('/proc/N_UPRC_LIST', {menu: 'front'}, ret=> this.prod = ret.data.rs1)
  },
  mounted() {
    this.checkAuth()
  },
  methods : {
    // 초기화
    doInit() {
      this.prod.forEach(e => this.inputCount(e, ''))
    },
    inputCount (item, v) {
      const T = this.T;
      item.cnt = v;
      item.sumprice = T.toInt(item.cnt) * T.toInt(item.price);

      this.sitem.iv_total_amt = this.prod.reduce((prev, item) => prev + T.toInt(item.sumprice), 0)
      this.sitem.iv_total_cnt = this.prod.reduce((prev, item) => prev + T.toInt(item.cnt), 0)
    },
    checkAuth() {
      // 개인변호사로 로그인하지 않은 경우 권한 체크
      if (this.$store.state.session.user.type == 'member') {
        ui.httpGet('/proc/N_FRONT_AUTH_CHECK',
        {
          iv_flag     : 'S',
          iv_viaregdt : '',
          iv_viaseq   : '',
        },
        ret => {
          // 증표권한 반환
          let buyAuthYn = ret.data.rs1[0].auth_yn

          // if (buyAuthYn == '0') {
          //   return ui.alert("증표 구입 권한이 없습니다.");
          // }
        })
      }
    },
    saveItem() {

      if (this.sitem.iv_total_cnt == 0 || !this.sitem.iv_total_cnt) {
        return ui.alert("수량을 입력해 주세요.");
      }

      let saveList = this.prod.filter(e => e.cnt > 0)

      // 구매 내역 메세지 출력
      let buy_txt = ''

      buy_txt += `<table class="tbl01 pop_buy_form"><thead><tr><th>증표 종류</th><th>금액</th><th>수량</th><th>계</th></thead></tr>`

      saveList.forEach(item => {
        // buy_txt += `${ item.name } : ${ T.comma(item.price) }원 X ${ T.comma(item.cnt) }건 = ${ T.comma(item.sumprice) }원\n`
        buy_txt += `<tr><th >${ item.name }</th><td class="al_amt">${ T.comma(item.price) } 원</td><td>${ T.comma(item.cnt) }</td><td class="al_amt">${ T.comma(item.sumprice) } 원</td></tr>`
      });

      //buy_txt += `\n<b class='ft20'>총 합계 : ${ T.comma(this.sitem.iv_total_amt) }원</b>\n`
      buy_txt += `<tr class="sum"><th><b>합계</b></th><th colspan="2"><b>${ T.comma(this.sitem.iv_total_cnt) } 장</b></th><th class="al_amt"><b>${ T.comma(this.sitem.iv_total_amt) } 원</b></th></tr>`

      buy_txt += `<tr class="sum"><th><b>비고</b></th><td colspan="3">${ this.sitem.iv_remk } </td></tr></table>`

      ui.confirm(`${buy_txt}
                  <font class="right b ft16 org01">신청하시겠습니까 ?</font>`
               , "신청 확인")
        .then(r => r && this.itemUpdate())

    },
    itemUpdate() {
      // 수량 입력된 건만 저장
      let saveList = this.prod.filter(e => e.cnt > 0)

      // 수량 입력된 건 #으로 연결
      saveList.forEach((item, i) => {
        this.sitem.iv_selldtlsseq = ((i == 0) ? '' : this.sitem.iv_selldtlsseq + '#') + (i+1)
        this.sitem.iv_caseclsf    = ((i == 0) ? '' : this.sitem.iv_caseclsf    + '#') + item.caseclsf
        this.sitem.iv_casetype    = ((i == 0) ? '' : this.sitem.iv_casetype    + '#') + item.casetype
        this.sitem.iv_numofcase   = ((i == 0) ? '' : this.sitem.iv_numofcase   + '#') + item.cnt
        this.sitem.iv_uprc        = ((i == 0) ? '' : this.sitem.iv_uprc        + '#') + item.price
        this.sitem.iv_viafee      = ((i == 0) ? '' : this.sitem.iv_viafee      + '#') + item.sumprice
      });

      this.$ui.httpPost("/proc/N_ORDER",
      { ...this.sitem
        , iv_accflag : 'I' // 신규등록
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 완료페이지로 이동
          this.$router.push({ path: 'buy_ok', query: { sellregdt, sellseq }})
        }

      })
    }
  }
}
</script>
<style scoped>

  .tbl01 th font{font-size: 11px; color:#ff6300 !important; }

  .tbl01 th:first-child { border-right:1px solid #999; width:25%; min-width:130px;}
  .tbl01 td { width:25%}

  .tbl01 th.al_amt { padding-right:80px; box-sizing: border-box; text-align: right;}
  .tbl01 td.al_amt { padding-right:90px;box-sizing: border-box; text-align: right;}

  @media screen and (max-width:640px){

    .tbl01 th {  padding : 8px 0; min-width:60px; width: auto;}
    .tbl01 th.viakind { width:130px;}
    .tbl01 th.viacnt { width:50px;}

    .tbl01 th font { font-size:11px;}
    .tbl01 td input { width:50px;}
    .tbl01 tr.sum th, tr.sum td { font-size:12px;}


    .tbl01 th.al_amt { padding-right:10px;box-sizing: border-box; text-align: right;}
    .tbl01 td.al_amt { padding-right:10px;box-sizing: border-box; text-align: right;}

  }

  #id_msg:hover .toggleInfo {  margin-top:30px; margin-left:-440px; display: inline-block; }
  .toggleInfo .tit_info {  color:#fff; display: inline-block; padding: 10px 15px 10px 40px; ;width:100%; box-sizing: border-box; font-size: 15px;;background:#333 url('/images/common/icon_info_org.png')  15px 50% no-repeat; }

  @media screen and (max-width:640px){

    #id_msg:hover .toggleInfo {  margin-top:30px; margin-left:-165px; display: inline-block; }
  }

</style>